import { FC } from 'react';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';
import { CheckIcon, XMarkIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import type { Availability as AvailabilityT } from '@/_constants/Availability.ts';
import Availability from '@/_constants/Availability.ts';

type AvailabilityBadgeProps = {
  type?: Omit<AvailabilityT, 'loading'> | 'base';
  content?: string;
};

const AvailabilityBadge: FC<PropsWithClassName<AvailabilityBadgeProps>> = ({ content, className, type = 'base' }) => {
  return (
    <div
      className={cn(
        'text-base font-bold px-2 py-1 flex gap-2 items-center rounded-xl',
        { 'bg-gray-100 border border-gray-100': type === 'base' },
        { 'bg-green-600 bg-opacity-15 border border-green-600': type === Availability.AVAILABLE },
        { 'bg-red-600 bg-opacity-15 border border-red-600': type === Availability.UNAVAILABLE },
        { 'bg-yellow-600 bg-opacity-15 border border-yellow-600': type === Availability.NOT_CHECKED },
        className
      )}
      title={content}
    >
      {type === Availability.AVAILABLE && (
        <div>
          <CheckIcon className="w-6 h-6 text-green-600" />
        </div>
      )}
      {type === Availability.UNAVAILABLE && (
        <div>
          <XMarkIcon className="w-6 h-6 text-red-600" />
        </div>
      )}
      {type === Availability.NOT_CHECKED && (
        <div>
          <ExclamationTriangleIcon className="w-6 h-6 text-yellow-600" />
        </div>
      )}
      <div className="truncate">{content}</div>
    </div>
  );
};

export default AvailabilityBadge;
